module.exports = __webpack_public_path__ + "img/tongzhi.557c8e3b.svg";